import { render, staticRenderFns } from "./RealFriendMeetingPostMakePage.vue?vue&type=template&id=1ef96e41&scoped=true"
import script from "./RealFriendMeetingPostMakePage.vue?vue&type=script&lang=js"
export * from "./RealFriendMeetingPostMakePage.vue?vue&type=script&lang=js"
import style0 from "./RealFriendMeetingPostMakePage.vue?vue&type=style&index=0&id=1ef96e41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef96e41",
  null
  
)

export default component.exports